(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-livelist"]) return;
  try {
    


async function testfunc(){
  let all_list_flg = false;
  let watch_list_flg = false;
  let jewelry_list_flg = false;
  let bridal_list_flg = false;
  let eye_wear_list_flg = false;
  let loop_count = 0;
  while(true){
    if(loop_count > 100){
      console.log('over 100 loop');
      break;
    }
    if(all_list_flg == false){
      if($('#all-list img').length){
        slide('all-list');
        all_list_flg = true;
        $("#main .sliderBox").fadeIn();
      }
    }
    if(watch_list_flg == false){
      if($('#watch-list img').length){
        slide('watch-list');
        watch_list_flg = true;
      }
    }
    if(jewelry_list_flg == false){
      if($('#jewelry-list img').length){
        slide('jewelry-list');
        jewelry_list_flg = true;
      }
    }
    if(bridal_list_flg == false){
      if($('#bridal-list img').length){
        slide('bridal-list');
        bridal_list_flg = true;
      }
    }
    if(eye_wear_list_flg == false){
      if($('#eye-wear-list img').length){
        slide('eye-wear-list');
        eye_wear_list_flg = true;
      }
    }
    loop_count += 1;

    if(all_list_flg && watch_list_flg && jewelry_list_flg && bridal_list_flg && eye_wear_list_flg){
      console.log('finish')
      break;
    }
    await new Promise(resolve => setTimeout(resolve, 100));
  }
}

$(document).ready(function(){
  testfunc();
  $('#next-live .tagfab-list').hide();
  $('.prev-list-bloc').hide();
  $('#all-list').show();
  $('#prev-all-list').show();
  $('#all-tab').on('click', function(){
    $('.comTabUl li').removeClass('on');
    let target = $(this).parent();
    target.addClass('on');

    $('#next-live .tagfab-list').hide();
    $('#all-list').show();

    $('.prev-list-bloc').hide();
    $('#prev-all-list').show();

    $('.comDot').hide();
    $('.comDot.all-list').show();
    slideslick["all-list"].slick('setPosition');
  });

  $('#watch-tab').on('click', function(){
    $('.comTabUl li').removeClass('on');
    let target = $(this).parent();
    target.addClass('on');

    $('#next-live .tagfab-list').hide();
    $('#watch-list').show();

    $('.prev-list-bloc').hide();
    $('#prev-watch-list').show();

    $('.comDot').hide();
    $('.comDot.watch-list').show();
    slideslick["watch-list"].slick('setPosition');
  });

  $('#jewelry-tab').on('click', function(){
    $('.comTabUl li').removeClass('on');
    let target = $(this).parent();
    target.addClass('on');

    $('#next-live .tagfab-list').hide();
    $('#jewelry-list').show();

    $('.prev-list-bloc').hide();
    $('#prev-jewelry-list').show();
    
    $('.comDot').hide();
    $('.comDot.jewelry-list').show();
    slideslick["jewelry-list"].slick('setPosition');
  });

  $('#bridal-tab').on('click', function(){
    $('.comTabUl li').removeClass('on');
    let target = $(this).parent();
    target.addClass('on');

    $('#next-live .tagfab-list').hide();
    $('#bridal-list').show();

    $('.prev-list-bloc').hide();
    $('#prev-bridal-list').show();
    
    $('.comDot').hide();
    $('.comDot.bridal-list').show();
    slideslick["bridal-list"].slick('setPosition');
  });

  $('#eye-wear-tab').on('click', function(){
    $('.comTabUl li').removeClass('on');
    let target = $(this).parent();
    target.addClass('on');

    $('#next-live .tagfab-list').hide();
    $('#eye-wear-list').show();

    $('.prev-list-bloc').hide();
    $('#prev-eye-wear-list').show();
    
    $('.comDot').hide();
    $('.comDot.eye-wear-list').show();
    slideslick["eye-wear-list"].slick('setPosition');
  });

});


let slideslick = [];
function slide(str) {
  var linum = $('#main .sliderBox #'+str+'.listUl [data-tagfab-live-list-row-item=true]').length;
  
  var length = linum;
  var shownum = linum - 1;
  if(shownum < 1){
    shownum = 1;
  }
  slideslick[str] = $('#main .sliderBox #'+str+'.listUl [data-tagfab-live-list-row="true"]').slick({
    arrows: true,
    slidesToShow: shownum,
    variableWidth: true,
    centerMode: true,
    centerPadding: '0',
  });
  
  slideslick[str].slick("slickPrev");

  $('#main .sliderBox #'+str+'.listUl .slick-slide [data-tagfab-live-list-row-item=true]').matchHeight();
  $('#main .sliderBox #'+str+'.listUl').on('beforeChange',function(event, slick, currentSlide, nextSlide){
    if(nextSlide==0){
      setTimeout(function(){
        $('#main .sliderBox #'+str+'.listUl .slick-slide[data-slick-index='+length+']').addClass('slick-current');
      },10);
    }
    if(nextSlide == length-1){
      setTimeout(function(){
        $('#main .sliderBox #'+str+'.listUl .slick-slide[data-slick-index=-1]').addClass('slick-current');
      },10);
    }
    nextSlide++;
    if(nextSlide < 10) {
      if(linum == '0'+nextSlide) {//スライドがマックス数に達したら1
        nextSlide = '01';
      } else {
        nextSlide = '0'+Number(nextSlide+1);
      }
    };
    $('#main .sliderBox .comDot.'+str+' .top').text(nextSlide);
  });
  if(linum < 10) {
    linum = '0'+linum;
  }
  $('#main .sliderBox .comDot.'+str+' .btm').text(linum);
}
  

//init
$('#main .sliderBox .comDot.all-list').fadeIn();
  

  } catch(e) { console.error(e); }
})();
})();
